/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef } from "react";
import { ShopTheLookGroup } from "~/common/Store/models/Brand";
import ExpandedShopTheLookCarousel from "./ExpandedShopTheLookCarousel";
import ShopTheLookDeviceView from "./ShopTheLookDeviceView";
import LimitSlider from "~/common/LimitSlider";
import ShopProductCard from "./ShopProductCard";

interface Props {
  featureGroup: ShopTheLookGroup;
}

const ExpandedShopTheLookGroup = ({ featureGroup }: Props) => {
  const [activeTagIndex, setActiveTagIndex] = useState<number | null>(null);
  const [isMobileTag, setIsMobileTag] = useState(false);
  const [activeLookIndex, setActiveLookIndex] = useState(0);
  const [activeSlider, setActiveSlider] = useState<LimitSlider>();
  const hasMultipleLooks = featureGroup.shopTheLooks.length > 1;
  const { shopTheLooks } = featureGroup;
  const productCardRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      productCardRef.current !== null &&
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      productCardRef.current.contains(event.target as HTMLElement)
    )
      return;
    setActiveTagIndex(null);
  };

  useEffect(() => {
    const shopLookCarousel = document.querySelector<HTMLElement>(
      '[data-component="shopLookCarousel"]'
    );
    if (shopLookCarousel) {
      const slider = new LimitSlider({
        selector: shopLookCarousel,
        onChange: () => {
          setActiveLookIndex(slider.currentSlide);
          setActiveTagIndex(null);
        },
      });
      setActiveSlider(slider);
    }
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleMobileShopArrow = (indexWithOffset: number) => {
    if (!activeSlider) {
      return;
    }
    setActiveLookIndex(indexWithOffset);
    setActiveTagIndex(null);
    activeSlider.goTo(indexWithOffset);
  };

  return (
    <>
      <div
        className={`shop-look${hasMultipleLooks ? " has-nav" : ""}`}
        id="shopTheLookBlock"
      >
        <div className="shop-look__photo-block">
          {hasMultipleLooks && (
            <div className="shop-look__nav">
              <div className="shop-look__nav--inner">
                <div className="shop-look__nav--title">
                  <h2>Shop The Look</h2>
                  <div
                    className="shop-look__look-title"
                    data-component="shopLookTitle"
                  >
                    {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
                    {shopTheLooks[activeLookIndex]!.title}
                  </div>
                </div>
                <ul className="shop-look__nav--list">
                  {shopTheLooks.map((look, index) => (
                    <li key={`ShopTheLookNav${index}`}>
                      <a
                        href={`#Look${index + 1}`}
                        className={`shop-look__nav--item${
                          index === activeLookIndex ? " active" : ""
                        }`}
                        onClick={() => {
                          setActiveLookIndex(index);
                          setActiveTagIndex(null);
                        }}
                      >
                        <div className="shop-look__nav--img">
                          <img src={look.thumbnail} alt={look.title} />
                        </div>
                        <span className="shop-look__nav--text">
                          {look.title}
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
                <div className="shop-look__slide-nav">
                  <a
                    type="button"
                    className={`slide-nav--previous icon-left-open${
                      activeLookIndex === 0 ? " disabled" : ""
                    }`}
                    onClick={() => handleMobileShopArrow(activeLookIndex - 1)}
                  >
                    <span className="accessibility-text">Previous Look</span>
                  </a>
                  <a
                    type="button"
                    className={`slide-nav--next icon-right-open${
                      activeLookIndex === shopTheLooks.length - 1
                        ? " disabled"
                        : ""
                    }`}
                    onClick={() => handleMobileShopArrow(activeLookIndex + 1)}
                  >
                    <span className="accessibility-text">Next Look</span>
                  </a>
                </div>
              </div>
            </div>
          )}
          <ul
            className="shop-look__photo-container show-sm"
            data-component="shopLookCarousel"
          >
            {shopTheLooks.map((look, index) => (
              <ShopTheLookDeviceView
                key={`ShopMobileLook${index}`}
                index={index}
                isMobile
                display={look.mobileDisplay}
                title={look.title}
                isActive={index === activeLookIndex}
                setActiveTagIndex={(n) => {
                  setActiveTagIndex(n);
                  setIsMobileTag(true);
                }}
              />
            ))}
          </ul>
          <ul className="shop-look__photo-container show-lg">
            {shopTheLooks.map((look, index) => (
              <ShopTheLookDeviceView
                key={`ShopDesktopLook${index}`}
                index={index}
                display={look.desktopDisplay}
                title={look.title}
                isActive={index === activeLookIndex}
                setActiveTagIndex={(n) => {
                  setActiveTagIndex(n);
                  setIsMobileTag(false);
                }}
              />
            ))}
          </ul>
          <div className="shop-look__tray">
            {activeLookIndex !== null && activeTagIndex !== null && (
              <ShopProductCard
                setActiveTagIndex={setActiveTagIndex}
                tag={
                  isMobileTag
                    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                      shopTheLooks[activeLookIndex]!.mobileDisplay.productTags[
                        activeTagIndex
                      ]!
                    : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                      shopTheLooks[activeLookIndex]!.desktopDisplay.productTags[
                        activeTagIndex
                      ]!
                }
                isMobile={isMobileTag}
                activeProductCardRef={productCardRef}
              />
            )}
          </div>
        </div>
        <br />
        {shopTheLooks.map((look, index) => (
          <ExpandedShopTheLookCarousel
            key={`${look.title}Carousel${index}`}
            carousel={look.carousel}
            carouselIndex={index + 1}
            visible={index === activeLookIndex}
          />
        ))}
      </div>
    </>
  );
};

export default ExpandedShopTheLookGroup;
